/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';

// components
import { Grid, Button, ProgressBar, Message } from '@design-system-coopeuch/web';
import InputCodeSMS from '../../molecules/InputCodeSMS/InputCodeSMS';
import SkeletonInputCodeSMS from '../../molecules/SkeletonInputCodeSMS/SkeletonInputCodeSMS';
import InputPasswordSimple from '../../molecules/InputPassword/InputPasswordSimple';
import ItemValidation from '../../molecules/ItemValidation/ItemValidation';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import sendAnalytics from '../../../../domain/utils/utilitarios-frontend-coopeuch/Analytics';
import dataLayerObject from '../../../../domain/utils/dataLayerObject';
// styles
import { StyledWrapperProgressBarPassword } from './styles';
// assets
import iconOtpInfo from '../../../assets/img/icon-otp-info.svg';
import iconPersonError from '../../../assets/img/icon-person-error-male-desktop.svg';

const ContentPasswordCreation = (props) => {
  const {
    phone,
    inputCodeSMS,
    password,
    confirmationPassword,
    passwordVisibility,
    confirmationPasswordVisibility,
    stateAuthSms,
    stateCreatingPassword,
    canCreatePassword,
    messagesInputAuthSms,
    onChangePasswordVisibility,
    onChange,
    onInvokeAuthSms,
    onTimeOverToRespond,
    onCreatePassword,
    onCloseCurrentModal,
  } = props;

  const [securityLevel, setSecurityLevel] = useState({
    name: 'initial',
    text: 'Ninguna',
    level: 0,
    borderInputColor: '#646569',
  });

  useEffect(() => {
    const qtyValidValidations = password.validations.filter((el) =>
      el.isValid(password.value)
    ).length;
    const percentageByValidation = 100 / password.validations.length;

    if (password.value === '')
      setSecurityLevel({ name: 'initial', text: 'Ninguna', level: 0, borderInputColor: '#646569' });
    else {
       /* istanbul ignore next */
      if (qtyValidValidations === 0)
        setSecurityLevel({
          name: 'none',
          text: 'Ninguna',
          level: 1,
          progressColor: '#E6838F',
          borderInputColor: '#CC284E',
        });
      else if (qtyValidValidations === 1)
        setSecurityLevel({
          name: 'low',
          text: 'Bajo',
          level: percentageByValidation * qtyValidValidations,
          progressColor: '#E6838F',
          borderInputColor: '#CC284E',
        });
      else if (qtyValidValidations === 3)
        setSecurityLevel({
          name: 'high',
          text: 'Alto',
          level: percentageByValidation * qtyValidValidations,
          progressColor: '#69C562',
          borderInputColor: '#0E891A',
        });
      else
        setSecurityLevel({
          name: 'middle',
          text: 'Medio',
          level: percentageByValidation * qtyValidValidations,
          progressColor: '#E3D076',
          borderInputColor: '#007DB7',
        });
    }
  }, [password]);
  
  const callInvokeSms = () => {
    onInvokeAuthSms()
    sendAnalytics(dataLayerObject.SEND_SMS_HABILITADORES)
  }

  const createPassword = () => {
    onCreatePassword()
    sendAnalytics(dataLayerObject.CREATE_PASSWORD_HABILITADORES)
  }

  

  return (
    <SimpleCard
      contentHeader={
        <article className="d-flex flex-column">
          <p className="font-size-18 line--height-24 font-weight-bold pr-4">
            Crea tu clave de internet para tu App y tu sitio en línea
          </p>
        </article>
      }
    >
      <Grid className="p-6">
        {stateCreatingPassword === 'otp' && (
          <>
            <Grid row className="p-0 justify-content-center">
              <Grid className="p-0 col-12 col-md-6 d-flex flex-column justify-content-center align-items-center">
                <img src={iconOtpInfo} alt="" width="144" />
                <Grid className="row justify-content-center px-0 mt-3 mb-4">
                  <p className="line-height-20 text-center">
                    Para crear tu clave es necesario que ingreses el código que recibirás en el
                    celular
                    <span className="text-primary-20 font-weight-bold text-color-red-coopeuch">
                      {phone ? ` +56${phone.slice(0, 1)}****${phone.slice(-4)}.` : ' +56*********'}
                    </span>
                  </p>
                </Grid>
                {stateAuthSms.step === 'initial' && (
                  <Grid className="row justify-content-center p-0">
                    <Button
                      color="secondary"
                      onClick={() => callInvokeSms()}
                      className="rounded-pill text-center justify-content-center font-size-14"
                      variant=""
                    >
                      Enviar código por SMS
                    </Button>
                  </Grid>
                )}
                {stateAuthSms.step === 'loading' && <SkeletonInputCodeSMS device="mobile" />}
                {stateAuthSms.step === 'input' && (
                  <>
                    <Grid row className="p-0 d-flex flex-column align-items-center">
                      <p className="font-size-14 font-weight-bold mb-1">Código SMS</p>

                      <InputCodeSMS
                        id={1}
                        values={inputCodeSMS.value}
                        disabled={inputCodeSMS.disabled}
                        secondsAvailableToRespond={
                          stateAuthSms.case === 'locked' || stateAuthSms.case === 'retry'
                            ? -1
                            : inputCodeSMS.secondsAvailableToRespond
                        }
                        objectMessage={messagesInputAuthSms[stateAuthSms.case]}
                        alignContent="center"
                        onChange={(smsCode) =>
                          onChange({
                            field: 'inputCodeSMS',
                            property: 'value',
                            value: smsCode,
                          })
                        }
                        onTimeOverToRespond={onTimeOverToRespond}
                        onInvokeAuthSms={onInvokeAuthSms}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
            {stateAuthSms.case === 'locked' && (
              <Grid className="p-0 mt-1">
                <Message
                  className="mt-2"
                  description={
                    <>
                      <p className="font-weight-bold text-color-error">
                        Has excedido el límite de intentos.
                      </p>
                      <p className="text-color-error">
                        La validación con codigo SMS se encuentra bloqueada. No te preocupes, puedes
                        volver a intentarlo en www.coopeuch.cl, opción “Ingresar”
                      </p>
                    </>
                  }
                  title=""
                  type="error"
                  closer={null}
                />
              </Grid>
            )}
          </>
        )}
        {stateCreatingPassword === 'password' && (
          <Grid className="d-flex flex-column justify-content-center align-items-center p-0">
            <Grid row className="w-100 p-0 mb-1">
              <Grid className="col-12 col-md-6 p-0 pr-md-3 mb-2 mb-md-0">
                <p className="font-weight-bold mb-1">Crea contraseña</p>
                <InputPasswordSimple
                  value={password.value}
                  name="password"
                  passwordVisibility={passwordVisibility}
                  maxLength={8}
                  borderColor={securityLevel.borderInputColor}
                  error={false}
                  onChange={({ target }) =>
                    onChange({
                      field: 'password',
                      property: 'value',
                      value: target.value,
                    })
                  }
                  onChangePasswordVisibility={onChangePasswordVisibility}
                  state="input"
                />
                <StyledWrapperProgressBarPassword
                  progressColor={securityLevel.progressColor || ''}
                  className="mt-2"
                >
                  <ProgressBar progress={securityLevel.level} />
                </StyledWrapperProgressBarPassword>
              </Grid>
              <Grid className="col-12 col-md-6 p-0 pl-md-3">
                <p className="font-weight-bold mb-1">Confirma contraseña</p>
                <InputPasswordSimple
                  value={confirmationPassword.value}
                  name="confirmationPassword"
                  passwordVisibility={confirmationPasswordVisibility}
                  maxLength={8}
                  borderColor={
                    confirmationPassword.value !== ''
                      ? confirmationPassword.value === password.value
                        ? '#69C562'
                        : '#CC284E'
                      : '#646569'
                  }
                  error={false}
                  onChange={({ target }) =>
                    onChange({
                      field: 'confirmationPassword',
                      property: 'value',
                      value: target.value,
                    })
                  }
                  onChangePasswordVisibility={onChangePasswordVisibility}
                />
                {confirmationPassword.value !== '' ? (
                  <ItemValidation
                    className="mt-2"
                    type={confirmationPassword.value === password.value ? 'success' : 'error'}
                  >
                    {confirmationPassword.value === password.value
                      ? 'Las contraseñas coinciden.'
                      : 'Las contraseñas no coinciden.'}
                  </ItemValidation>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
            <Grid>
              <ItemValidation
                type={
                  password.validations[0].isValid(password.value)
                    ? 'success'
                    : password.value === ''
                    ? 'disabled'
                    : 'error'
                }
              >
                <p>
                  Tu contraseña debe tener entre <strong>6 y 8 caracteres.</strong>
                </p>
              </ItemValidation>
              <ItemValidation
                type={
                  password.validations[1].isValid(password.value)
                    ? 'success'
                    : password.value === ''
                    ? 'disabled'
                    : 'error'
                }
              >
                <p>
                  Debe contener <strong>letras y números.</strong>
                </p>
              </ItemValidation>
              <ItemValidation
                type={
                  password.validations[2].isValid(password.value)
                    ? 'success'
                    : password.value === ''
                    ? 'disabled'
                    : 'error'
                }
              >
                <p>
                  Debe contener al menos <strong>una letra minúscula y mayúscula.</strong>
                </p>
              </ItemValidation>
            </Grid>
          </Grid>
        )}
        {stateCreatingPassword === 'errorPassword' && (
          <Grid className="p-0 m-0 d-flex flex-column flex-grow-1 align-items-center">
            <img src={iconPersonError} alt="" width="112" />
            <article className="d-flex flex-column align-items-center">
              <p className="font-size-14 line-height-20 text-center mt-2 w-75">
                No pudimos crear la tu clave de internet, reintenta o créala en www.coopeuch.cl,
                opción “Ingresar”
              </p>
            </article>
          </Grid>
        )}
      </Grid>
      {stateCreatingPassword === 'password' && (
        <Grid className="p-4 d-flex border-top justify-content-center justify-content-md-end">
          <Button
            color="secondary"
            prefix="line-lock"
            disabled={!canCreatePassword}
            onClick={() => createPassword()}
            variant=""
          >
            Crear y confirmar contraseña
          </Button>
        </Grid>
      )}
      {stateCreatingPassword === 'errorPassword' && (
        <Grid className="p-4 d-flex border-top justify-content-center">
          <Button
            color="primary"
            prefix=""
            disabled={!canCreatePassword}
            onClick={() => onCloseCurrentModal()}
            variant=""
          >
            Cerrar y Reintentar
          </Button>
        </Grid>
      )}
    </SimpleCard>
  );
};

export default ContentPasswordCreation;
